import React, { useEffect, useState } from 'react';
import { collection, doc, onSnapshot, query, setDoc, where } from 'firebase/firestore';
import { db } from '../../../firebase/config';
import { useCarrierFeature } from '../../../hooks/useCarrierFeature';
import { COLORS } from '../../../styles/tokens';

// Admin: bryter for transportørfunksjonen (settings/platform.carrierOrgEnabled) og liste over transportørfirmaer.
export default function AdminCarriers() {
  const feature = useCarrierFeature();
  const [orgs, setOrgs] = useState([]);
  const [error, setError] = useState(false);
  const [toggleError, setToggleError] = useState(false);

  useEffect(() => onSnapshot(
    query(collection(db, 'organizations'), where('type', '==', 'carrier')),
    snap => setOrgs(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    () => setError(true),
  ), []);

  async function toggle() {
    setToggleError(false);
    try {
      await setDoc(doc(db, 'settings', 'platform'), { carrierOrgEnabled: !feature.enabled }, { merge: true });
    } catch {
      setToggleError(true);
    }
  }

  return (
    <div style={styles.page}>
      <div style={styles.flagCard}>
        <div>
          <div style={styles.flagTitle}>Transportørfunksjon</div>
          <div style={styles.hint}>
            {feature.enabled
              ? 'På: transportfirmaer kan opprettes og brukes.'
              : 'Av: ingen kan opprette eller bruke transportørfirma ennå.'}
          </div>
        </div>
        <button type="button" role="switch" aria-checked={feature.enabled} aria-label="Transportørfunksjon" onClick={toggle}
                style={{ ...styles.track, background: feature.enabled ? COLORS.success : COLORS.border }}>
          <span style={{ ...styles.knob, transform: feature.enabled ? 'translateX(20px)' : 'none' }} />
        </button>
      </div>

      {toggleError && <p role="alert" style={styles.error}>Kunne ikke endre bryteren. Prøv igjen.</p>}
      {error && <p role="alert" style={styles.error}>Kunne ikke hente firmaene. Last siden på nytt.</p>}
      <h2 style={styles.heading}>Transportørfirmaer</h2>
      {orgs.length === 0 && !error && <p style={styles.hint}>Ingen firmaer opprettet ennå.</p>}
      {orgs.map(o => (
        <div key={o.id} style={styles.row}>
          <strong>{o.orgName}</strong>
          <span style={styles.hint}>Org.nr. {o.orgNumber}</span>
        </div>
      ))}
    </div>
  );
}

const styles = {
  page: { padding: 16, overflowY: 'auto' },
  flagCard: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16, background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 12, padding: '14px 16px', marginBottom: 14 },
  flagTitle: { fontWeight: 700, fontSize: 15, color: COLORS.textDark },
  hint: { fontSize: 12.5, color: COLORS.textMid, marginTop: 2 },
  heading: { fontSize: 16, margin: '16px 0 8px', color: COLORS.textDark },
  row: { display: 'flex', justifyContent: 'space-between', gap: 12, padding: '10px 0', borderBottom: `1px solid ${COLORS.border}`, color: COLORS.textDark },
  error: { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '10px 12px', borderRadius: 10, fontSize: 14 },
  track: { width: 44, height: 24, borderRadius: 12, border: 'none', padding: 2, cursor: 'pointer', flexShrink: 0, transition: 'background 0.2s' },
  knob: { display: 'block', width: 20, height: 20, borderRadius: '50%', background: '#fff', transition: 'transform 0.2s' },
};
